import { getEncryptionPublicKey } from "@metamask/eth-sig-util";
import { Buffer } from "buffer";
import { buildEddsa } from "circomlibjs";

export type HolderCommitment = {
  holderCommitment: string;
  encryptionPubKey: string;
};

// NOTE: We need to discuss and rewrite how exactly we derive the eddsa key
export const generateHolderCommitment = async (privateKey: string) => {
  // Generate holder commitment using EdDSA
  const eddsa = await buildEddsa();
  const privateKeyFE = eddsa.pruneBuffer(Buffer.from(privateKey));
  const publicKey = eddsa.prv2pub(privateKeyFE);
  const commitment: string = eddsa.babyJub.F.toObject(publicKey[0]).toString();

  const encryptionPubKey = getEncryptionPublicKey(privateKey);

  return {
    holderCommitment: commitment,
    encryptionPubKey,
  };
};
